import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { POD_LEAD, LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Campaign Health's extras (C-16 S8, GLE-8406): the month's goal and pace,
 * the launch checklist, the triage log and the schedule link. Dark until
 * `manage/me.features.campaign_ops`, inside a window from the release
 * (2026-10-31) to release + 14 days; each user sees it on two ET days from the switch-on
 * (C16-D425). Pod Leads read the checklist and the log, without goals.
 */
export const CAMPAIGN_HEALTH_EXTRAS_2026_10_28: WhatsNewEntryI = {
  id: "2026-10-28-campaign-health-extras",
  feature: "campaign_ops",
  startsAt: "2026-10-31T04:00:00.000Z",
  endsAt: "2026-11-14T05:00:00.000Z",
  title: {
    [LGA]: "Campaign Health has goals, a checklist and a triage log",
    [ADMIN]: "Campaign Health has goals, a checklist and a triage log",
    [POD_LEAD]: "Campaign Health has a checklist and a triage log",
  },
  intro: {
    [LGA]:
      "Command Center's launch checklist and triage log moved into Team → Health → Campaign Health, next to each campaign's numbers.",
    [ADMIN]:
      "Command Center's launch checklist and triage log moved into Team → Health → Campaign Health, next to each campaign's numbers.",
    [POD_LEAD]:
      "See what your LGA logged on each campaign, and where its launch stands.",
  },
  sections: [
    {
      id: "goal",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.HEALTH,
      title: "This month's goal",
      items: [
        "Each campaign's QMs this month against its target from Team → Pipeline, with today's pace.",
        "The new Behind pace chip lists the campaigns under pace.",
      ],
    },
    {
      id: "checklist-triage",
      audiences: [POD_LEAD, LGA, ADMIN],
      icon: WHATS_NEW_ICONS.SPARKLES,
      title: "Launch checklist and triage log",
      items: [
        "Open a campaign's row: its 10 go-live items, with who ticked each and when.",
        "Dated notes with a severity, newest first. LGAs and Admins add them.",
        "See the campaign's schedule from the same row.",
      ],
      link: {
        label: "Open Campaign Health",
        href: Router.manageHealth("campaign-health"),
      },
    },
    {
      id: "pause-saturday",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.CALENDAR,
      title: "Pause a campaign's blocks, Saturday and Sunday on or off",
      items: [
        "Team → Calendar → Capacity → Edit settings: pause a campaign's blocks. Its future blocks are cancelled, each caller is told, and nobody can book it until you resume.",
        "Turn Saturday or Sunday on or off for a campaign. Sunday starts off everywhere; on, callers see a Sunday column in My Week. Off cancels that day's future blocks.",
        "Blocks cancelled this way never count against a caller's score.",
      ],
      link: {
        label: "Open Capacity",
        href: Router.manageCalendar(undefined, "capacity"),
      },
    },
  ],
};
